import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@tanstack/react-router';
import { styled } from 'styletron-react';
const NavigationLink = styled(Link, {
    textDecoration: 'none',
});
const LINK_ACTIVE_OPTIONS = { includeSearch: false };
export const NavigationMenuItemWrapper = ({ item, renderContent, }) => {
    const { linkProps, isActiveOverride } = item.additionalData;
    return (_jsx(NavigationLink, { ...linkProps, activeOptions: LINK_ACTIVE_OPTIONS, children: ({ isActive }) => renderContent({
            isActive: isActiveOverride ?? isActive,
        }) }));
};
